import React from 'react';

type SpielerKlassenkarte = {
    farbe: string;
    kaestchen: string;
    hinweis: string;
    x: number;
    y: number;
};

const Spieler = ({ farbe, kaestchen, hinweis, x, y }: SpielerKlassenkarte) => {
    return (
        <g onClick={() => console.log({ farbe, kaestchen, hinweis })}>
            <circle cx={x} cy={y} r="30" fill={farbe}/>
            <rect x={x - 47} y={y + 15} width="90" height="20" fill={kaestchen}/>
            <text x={x- 40} y={ y + 30}>{hinweis}</text>
        </g>
    );
}

export const SvgPlayground = () => {
  const n = 7;
  const winkel = 2 * Math.PI / n;
  return (
    <div>
        <svg width="3000px" height="1000px">
            <Spieler x={200}   y={200} farbe="brown" kaestchen="grey" hinweis="???"/>
            <Spieler x={Math.cos(winkel) * 100 + 200}   y={Math.sin(winkel) * 100 + 200} farbe="darkred" kaestchen="red" hinweis="Frankreich"/>
            <Spieler x={Math.cos(winkel*2) * 100 + 200} y={Math.sin(winkel*2) * 100 + 200} farbe="green" kaestchen="lightgreen" hinweis="Asterix"/>
            <Spieler x={Math.cos(winkel*3) * 100 + 200} y={Math.sin(winkel*3) * 100 + 200} farbe="blue" kaestchen="lightblue" hinweis="Froschschenkel"/>
            <Spieler x={Math.cos(winkel*4) * 100 + 200} y={Math.sin(winkel*4) * 100 + 200} farbe="yellow" kaestchen="lightyellow" hinweis="Gallien"/>
            <Spieler x={Math.cos(winkel*5) * 100 + 200} y={Math.sin(winkel*5) * 100 + 200} farbe="purple" kaestchen="lightpurple" hinweis=""/>
            <Spieler x={Math.cos(winkel*6) * 100 + 200} y={Math.sin(winkel*6) * 100 + 200} farbe="darkorange" kaestchen="orange" hinweis="Bretagne"/>
            <Spieler x={Math.cos(winkel*7) * 100 + 200} y={Math.sin(winkel*7) * 100 + 200} farbe="magenta" kaestchen="lightmagenta" hinweis=""/>
        </svg>
    </div>
  );
};
